import { CommonModule, ViewportScroller } from '@angular/common';
import { AfterViewInit, Component, OnInit } from '@angular/core';

import i18next from 'i18next';
import { MatCardModule } from '@angular/material/card';
import { NgbCarouselModule } from '@ng-bootstrap/ng-bootstrap';

import { RequestListResponse } from 'src/app/shared/model/request-list.model';
import { User } from 'src/app/shared/model/user.model';
import { SharedModule } from 'src/app/shared/shared.module';
import { Translate } from '../../shared/utils/translate';
import { OrderService } from 'src/app/core/services/order.service';
import { StorageService } from 'src/app/core/storage/storage.service';

import { CardComponent } from 'src/app/shared/components/card/card.component';
import { NavigationService } from 'src/app/core/services/navigation.service';
import { MatButtonModule } from '@angular/material/button';
import { Router } from '@angular/router';
import { Authorizations } from 'src/app/shared/model/authorization.model';
import { UserService } from 'src/app/core/services/user.service';
import { HttpErrorResponse, HttpStatusCode } from '@angular/common/http';
import { RequestStatus } from 'src/app/shared/model/requestStatus.enum';
import { ApproversTypes } from 'src/app/shared/model/approversTypes.enum';
import { HandlePermissions } from 'src/app/shared/utils/permissions';

@Component({
  standalone: true,
  selector: 'app-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.scss'],
  imports: [
    CommonModule,
    CardComponent,
    MatCardModule,
    MatButtonModule,
    NgbCarouselModule,
    SharedModule
  ]
})
export class LandingComponent implements OnInit, AfterViewInit {
  user!: User;
  listRequestType = 'ACTIVE';
  requestList!: RequestListResponse[];
  campaignsList: any;
  authorizationsList?: Authorizations[];
  showCarousel = false;
  enableCampaigns!: boolean;
  authorizations = [];
  imagesLoaded = 0;

  spinner = true;
  vehiclesError = '';
  authorizationsError = '';
  showNavigationArrows = false;
  showNavigationIndicators = true;
  isPec = false;
  controllerUserId: string | null = null;
  delegatedApproverUserId: string | null = null;

  constructor(
    private storageService: StorageService,
    private orderService: OrderService,
    private scroller: ViewportScroller,
    private navigationService: NavigationService,
    private translate: Translate,
    private router: Router,
    private userService: UserService,
    private handlePermissions: HandlePermissions
  ) {}

  ngOnInit(): void {
    //this.storageService.set('transfers', false);
    this.storageService.set('landing2', false);
    this.storageService.set('substitutionVehicle', null);
    this.storageService.set('substitutionVin', null);
    this.storageService.set('substitutionRequestNumber', null);
    this.storageService.set('navigation', 'home');
    this.storageService.set('pageList', 1);
    if (this.storageService.get('config')) {
      this.user = this.storageService.get('config');
      this.checkDlaOrCnt(this.user.nis);
    }
    this.isPec = this.userService.isPec(this.user?.category);
    this.spinner = true;
    const active = true;
    if (
      !!this.user &&
      (this.user.authorizer === 'CONTROLLER' ||
        this.user.authorizer === 'DELEGATED_APPROVER' ||
        this.isPec)
    ) {
      this.getAuthorizations();
    }
    this.getListRequest(active);
    this.authorizations.length <= 0
      ? (this.authorizationsError = i18next.t('landingNoAuthorizations'))
      : (this.authorizationsError = '');
    this.handlePermissions.setRequestPosition();
    this.enableCampaigns = this.handlePermissions.getPermission('CAMPAIGN');
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.navigationService.handleNavigationView('home');
    }, 0);
  }

  getListRequest(active: boolean) {
    this.orderService.showOrdersList('requests', active, 1).subscribe({
      next: (resp) => {
        this.spinner = false;
        this.requestList = resp.requests;
        this.requestList = resp.requests.slice(0, 3);
        this.requestList.length <= 0
          ? (this.vehiclesError = i18next.t('landingNoVehicles'))
          : (this.vehiclesError = '');
        for (const item of this.requestList) {
          /*if(item.requestType === 'PROJECT' || item.requestType === 'GENERAL_SERVICES') {
            this.storageService.set('transfers', true);
          }*/
          item.requestType = this.translate.translateRequestTypes(
            item.requestType
          );
        }
      },
      error: (err: HttpErrorResponse) => {
        this.spinner = false;
        this.vehiclesError =
          err.status === HttpStatusCode.NotFound
            ? i18next.t('landingNoVehicles')
            : i18next.t('landingVehiclesError');
      }
    });
    this.authorizations.length <= 0
      ? (this.authorizationsError = i18next.t('landingNoAuthorizations'))
      : (this.authorizationsError = '');
  }

  getAuthorizations() {
    this.orderService
      .getRequestApprover(
        RequestStatus.PENDING_APPROVAL,
        this.controllerUserId!,
        this.delegatedApproverUserId!,
        1
      )
      .subscribe({
        next: (res: any) => {
          this.authorizations = res.requests.slice(0, 3);
          this.authorizations.length <= 0
            ? (this.authorizationsError = i18next.t('landingNoAuthorizations'))
            : (this.authorizationsError = '');
        },
        error: () => {
          this.authorizationsError = i18next.t('landingNoAuthorizations');
        }
      });
  }

  checkDlaOrCnt(nis: string) {
    if (
      this.user.authorizer === ApproversTypes.DLA ||
      this.userService.isPec(this.user?.category)
    ) {
      this.delegatedApproverUserId = nis;
    }
    if (this.user.authorizer === ApproversTypes.CNT) {
      this.controllerUserId = nis;
    }
    if (this.user.authorizer === ApproversTypes.ALL) {
      this.controllerUserId = nis;
      this.delegatedApproverUserId = nis;
    }
  }

  scrollDown(target: string) {
    this.scroller.scrollToAnchor(target);
  }
  goToCampaign(data: any) {
    this.storageService.set('stock', data);
    this.router.navigate(['/campaign-detail']);
  }
}
